import React, { useEffect, useRef } from 'react'
import { useInView } from 'react-intersection-observer'
import { analytics, eventEmitter } from '../../common/baseData'

function ProductSlider(props) {
  const {title, totalTitle, totalLink, children, gaParams} = props;
  const rootRef = useRef(null)

  const { ref: inViewRef, inView } = useInView({
    threshold: 0,
    triggerOnce: true
  })

  const setRootRef = node => {
    rootRef.current = node
    inViewRef(node)
  }

  useEffect(() => {
    if (!(rootRef.current instanceof HTMLElement)) return

    eventEmitter.emit('handleWishlistItems', {
      node: rootRef.current.querySelectorAll('[data-container="favorite"]'),
      range: 'product'
    })

    eventEmitter.emit('handleCompareItems', {
      node: rootRef.current.querySelectorAll('[data-container="compare"]'),
      range: 'product'
    })
  }, [])

  // GA4 / sending item list view event
  useEffect(() => {
    if (!inView || !gaParams?.productIds?.length) return

    analytics.viewItemList(gaParams.productIds, gaParams.item_list_name, gaParams.item_list_id)
    .then(response => {
      analytics.view_item_list(response.events[0].params);
      console.info(response)
    })
    .catch(reason => (console.error(reason)))
  }, [inView])

  return (
    <section className={`my-10`} ref={setRootRef}>
      <div
        className="px-5 pb-3 flex justify-between items-baseline desktop:justify-normal desktop:gap-3 desktop:px-0">
            <span
              className="text-[16px] leading-[24px] font-medium text-grey-90 desktop:text-[24px] desktop:leading-[36px]">
                {title}
            </span>
        <a href={totalLink}
           className="inline-block w-auto text-blue-primary text-[14px] leading-[21px] underline desktop:text-[16px] desktop:leading-[24px] hover:no-underline">
          {totalTitle}
        </a>
      </div>
      <ul
        className="px-5 desktop:px-0 flex overflow-x-scroll scroll-smooth snap-x snap-mandatory overscroll-x-none invisible-scrollbar">
        {children}
      </ul>
    </section>
  );
}

export default ProductSlider;